import request from "@/service";

/* 短信管理-统计分页列表 */
export function smsPage(data) {
  return request({
    url: "/user/sys/sms/page",
    method: "get",
    params: data
  });
}

/* 短信管理-系统短信分页列表 */
export function sysSmsPage(data) {
  return request({
    url: "/user/sys/sms/sysPage",
    method: "get",
    params: data
  });
}

/* 短信发送状态分页列表 */
export function smsStatusPage(data) {
  return request({
    url: "/user/sys/sms/statusPage",
    method: "get",
    params: data
  });
}
/* 删除短信记录 */
export function deleteSms(data) {
  return request({
    url: "/user/sys/sms/delete",
    method: "delete",
    data
  });
}
/* 重新发送短信 */
export function resendSms(data) {
  return request({
    url: "/user/sys/sms/resend",
    method: "post",
    data
  });
}
/* 回复短信分页列表 */
export function replySms(data) {
  return request({
    url: "/user/sys/sms/replyPage",
    method: "get",
    params: data
  });
}
/* 短信回复详细分页列表 */
export function replyDetail(data) {
  return request({
    url: "/user/sys/sms/pageQuery",
    method: "get",
    params: data
  });
}

/* 导出回复短信 */
export function exportReplyInfo(params) {
  return request({
    url: `/user/sys/sms/export`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}
